import { action, computed, makeObservable, observable } from 'mobx'
import UiLstStoreBase from '../../cls/stores/UiLstStoreBase'

/**
 * @class UiLstUsersStore
 * @extends UiLstStoreBase
 * @description This class represents the store for the UI list of users. It extends the UiLstStoreBase class and initializes the users store with default filters.
 */
class UiLstUsersStore extends UiLstStoreBase {
	clientIds = []
	teamIds = []

	/**
	 * @constructor
	 * @param {object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of UiLstUsersStore with the specified root store and initializes the store with default filters.
	 */
	constructor(rootStore) {
		// Call the parent constructor with the root store and default filters
		super(rootStore, {
			show_all: false
		})

		makeObservable(this, {
			clientIds: observable,
			teamIds: observable,
			setClientIds: action,
			setTeamIds: action,
			clientAndTeamIds: computed
		})
	}

	setClientIds(ids) {
		this.clientIds = ids
	}

	setTeamIds(ids) {
		this.teamIds = ids
	}

	get clientAndTeamIds() {
		const ids = [...this.clientIds, ...this.teamIds]
		return [...new Set(ids)]
	}
}

export default UiLstUsersStore
